<div class="goal-container">
    <div class="header">
        <h1>{{"Delete Goal" | translate}}</h1>
        <mat-icon (click)="onCancelClick()" class="close-button" mat-dialog-close>
            clear
        </mat-icon>
    </div>
    <div class="sub-header">
        <p>{{"Are you sure you want to delete this Goal?" | translate}}</p>
        <a mat-button color="primary" (click)="dialogRedirect()">{{"Update this Goal instead" | translate}}</a>
    </div>

    <!-- Form Element Here -->
    <app-goal-form 
        (formSubmit)="onConfirmDelete($event)" 
        (formCancel)="onCancelClick()"
        action="delete"
        [existingData]="data"
    >
    </app-goal-form>
    <!-- End of Form Element -->
    
</div>